import {
  TEMP_UNIT_KEY,
  // PRECIP_UNIT_KEY,
  WIND_UNIT_KEY
} from '../misc/constants';

export const CHART_CONFIGS = {
  temperature: {
    dataKeys: ['temperatureMin', 'temperature', 'temperatureMax'],
    minKey  : 'temperatureMin',
    maxKey  : 'temperatureMax',
    colors: ['#6B95FF', '#FFA46B', '#FF6B6B'],
    bandColors: ['#FF6B6B', '#6B95FF'],
    domainMargin: 0,
    yAxisLabel: (u) => `Temperature (°${u[TEMP_UNIT_KEY]})`,
    showBand: true, 
  },

  precipitation: {
    dataKey: 'precipitation',
    minKey: 'precipitationMin',
    maxKey: 'precipitationMax',
    color: '#5ED8FF',
    fillId: 'colorPrecip',
    domainMargin: 0,
    yAxisLabel: () => `Precipitation (mm)`,
    showBand: false, 
  },

  allSky: {
    dataKey: 'watts',
    minKey: 'wattsMin',
    maxKey: 'wattsMax',
    color: '#FFF175',
    fillId: 'colorAllSky',
    domainMargin: 10,
    yAxisLabel: () => 'Solar Radiation (Watts)',
    showBand: false, 
  },

  cloud: {
    dataKey: 'cloud',
    minKey: 'cloudMin',
    maxKey: 'cloudMax',
    color: '#B8B8B8',
    fillId: 'colorCloud',
    domainMargin: 0,
    yAxisLabel: () => 'Cloud Cover (%)',
    showBand: false, 
  },

  rh2m: {
    dataKey: 'rh2m',
    minKey: 'rh2mMin',
    maxKey: 'rh2mMax',
    color: '#7DB9FF',
    fillId: 'colorRh2m',
    domainMargin: 0,
    yAxisLabel: () => 'Relative Humidity (%)',
    showBand: false, 
  },

  windSpeed: {
    dataKey: 'windSpeed',
    minKey: 'windSpeedMin',
    maxKey: 'windSpeedMax',
    color: '#BBD531',
    fillId: 'colorWindSpeed',
    domainMargin: 1,
    yAxisLabel: (unitSettings) => `Wind Speed (${unitSettings[WIND_UNIT_KEY]})`,
    showBand: false, 
  },
  
};